export default __webpack_public_path__ + "static/media/charts.229b4554.svg";